<div class="d-flex flex-column justify-content-center align-items-center">
  <div class="text-center">
    <h1 class="text-dark-85 fw-bold">403</h1>
    <h3 class="text-dark-65 fw-bold">Access Denied</h3>
    <p class="text-dark-50 fw-bold mt-12">
      We're sorry, you do not have permission to view this page or resource.
      <br />
      Please contact your Account Executive.
    </p>
    @if (hasPermissions) {
      <div class="pb-lg-0 pb-20">
        <button type="button" class="btn btn-pill btn-primary px-15 mt-2" (click)="back()">
          Back to Homepage
        </button>
      </div>
    }
    @if (!hasUserRequiredPermissionToUseApp) {
      <div class="pb-lg-0 pb-20">
        <button type="button" class="btn btn-pill btn-primary px-15 mt-2" (click)="logout()">
          Logout
        </button>
      </div>
    }
  </div>
</div>
